module.exports = __webpack_public_path__ + "img/24_bed.bd2a5931.jpg";